<template>
    <div class="of-content3-topper">
        <div class="main-svg">
            <img :src="topper.mainSvg" alt="" srcset="">
        </div>
        <div class="content">
            <h1 class="title" v-html="topper.title"></h1>
            <p v-html="topper.text"></p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'topper',
        props: ['view'],
        data() {
            return {
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-mobile-topper.svg',
                title: 'Funnels',
                text: 'Aptent varius a velit dictum convallis cursus nam ullamcorper. Aliquet tellus per quisque. Feugiat nibh eleifend fusce inceptos nulla tellus quis sem.'
            }
        },
        computed: {
            topper: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        },
        created(){

        },
        mounted(){

        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/office";

    .of-content3-topper {
        font: inherit;

        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
        justify-items: stretch;
        align-items: stretch;
        justify-content: stretch;
        align-content: stretch;

        padding: 6.2em 0 1.3em 0; /* 62px 0 13px 0 */

        .main-svg{
            font: inherit;
            padding: 0 0 0 4.4em; /* 0 0 0 44px */

            img{
                width: 100%;
                height: auto;
            }
        }
        .content{
            font: inherit;
            text-align: left;
            box-sizing: border-box;

            display: flex;
            align-items: start;
            justify-content: center;
            flex-direction: column;

            padding: 0 4.4em 0 8.3em; /* 0 44px 0 83px*/

            h1,
            .title{
                font: inherit;
                color: $of-color1;

                font-family: "Mulish";
                font-size: 7em; /*70px*/
                font-weight: 700;
                line-height: 1.2;

                margin: 0 0 0.071428571em 0; /* 0 0 5px 0 */
                padding: 0;
            }

            p,
            .text{
                font: inherit;
                box-sizing: border-box;
                max-width: 75%; /*381px*/

                color: $of-color2;
                font-size: 2em; /*20px*/
                font-weight: 900;
                line-height: 1.2;

                padding: 0;
                margin: 0;
            }
        }
    }

    @media (max-width: 768px) { /* smartphones e tablets */
        .of-content3-topper{
            font: inherit;

            grid-template-columns: 1fr;
            grid-template-rows: repeat(2, auto);
            align-items: start;
            justify-items: center;

            .main-svg{
                font: inherit;

                width: 90%;
                padding: 0;
            }
            .content{
                font: inherit;

                width: 90%;
                padding: 6.2em 0; /* 62px */

                p,
                .text{
                    max-width: 100%;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-3/topper.vue